import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select'

import { SwitchKeySelect, SwitchValueField } from './switchKeyField'

const validationOptions = [
  { value: 'equal', label: '= La valeur est égale à la valeur du switch' },
  { value: 'contain', label: '∈ Le texte du switch contient au moins une partie du texte de la valeur' },
  { value: 'exist', label: '∃ La clé existe, peu importe la valeur' },
  { value: 'greater', label: '> La valeur du switch est strictement supérieure' },
  { value: 'less', label: '< La valeur du switch est strictement inférieure' },
  { value: 'isSolution', label: "🕵🏼 Au moins un des éléments est solution de l'enquête" },
  { value: 'isNotSolution', label: "🕵🏼 Aucun des éléments n'est solution de l'enquête" }
]

export const SwitchCondition = ({ formData, formContext, onChange, schema, uiSchema }) => {
  const { categories } = formContext
  const registry = formContext.experience?.switchRegistry || []
  const options = useRef(
    (categories || []).map(category => ({
      label: category.label,
      options: (category.variants || []).map(variant => ({ value: variant._id, label: variant.label }))
    }))
  ).current

  const isInvestigation = ['isSolution', 'isNotSolution'].includes(formData?.method)
  const showValue = !isInvestigation && formData?.method !== 'exist'
  // Posé sur une propriété d'objet, le champ porte lui-même le retrait de la condition : aucun bouton de liste ne l'entoure.
  const isRemovable = uiSchema?.['ui:options']?.removable

  const [value, setValue] = useState({ array: [] })

  useEffect(() => {
    const parsedValue = parseArray(formData?.value, [])
    setValue({
      array: options.flatMap(category => category.options || []).filter(option => parsedValue.includes(option.value))
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.value, isInvestigation])

  // Tant que la condition n'existe pas, seul son ajout est proposé.
  if (!formData) {
    return (
      <div className="form-group field field-object" style={headerStyle}>
        {schema?.title && <label className="control-label">{schema.title}</label>}
        <button type="button" className="btn btn-info btn-add" onClick={() => onChange({ method: 'equal' })}>
          <i className="glyphicon glyphicon-plus" /> Ajouter une condition
        </button>
      </div>
    )
  }

  return (
    <div className="form-group field field-object">
      {(schema?.title || isRemovable) && (
        <div style={headerStyle}>
          {schema?.title && <label className="control-label">{schema.title}</label>}
          {isRemovable && (
            <button
              type="button"
              className="btn btn-danger array-item-remove"
              title="Supprimer la condition"
              onClick={() => onChange(undefined)}
            >
              <i className="glyphicon glyphicon-remove" />
            </button>
          )}
        </div>
      )}
      <div className="form-group field field-string">
        <label className="control-label" htmlFor="method">
          Méthode de validation
        </label>
        <select
          id="method"
          value={formData.method || 'equal'}
          className="form-control"
          onChange={event => onChange({ ...formData, method: event.target.value })}
        >
          {validationOptions.map(option => (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {isInvestigation ? (
        <div className="form-group field field-string">
          <label className="control-label" htmlFor="key">
            Identifiant de l'enquête
          </label>
          <input
            id="key"
            type="text"
            className="form-control"
            onChange={event => onChange({ ...formData, key: event.target.value })}
            value={formData.key || ''}
          />
        </div>
      ) : (
        <SwitchKeySelect
          registry={registry}
          value={formData.key || ''}
          label="Clé"
          onChange={key => onChange({ ...formData, key })}
        />
      )}

      {isInvestigation ? (
        <div className="form-group field field-string">
          <label className="control-label" htmlFor="value">
            Éléments
          </label>
          <Select
            value={value.array}
            onChange={opts => onChange({ ...formData, value: JSON.stringify(opts.map(option => option.value)) })}
            options={options}
            isMulti={true}
            closeMenuOnSelect={false}
            menuPortalTarget={document.body}
            placeholder={'Sélectionnez un élément'}
            noOptionsMessage={() => "Pas d'élément à afficher"}
            menuPlacement="auto"
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          />
        </div>
      ) : (
        showValue && (
          <SwitchValueField
            registry={registry}
            switchKey={formData.key || ''}
            value={formData.value || ''}
            label="Valeur"
            onChange={val => onChange({ ...formData, value: val })}
          />
        )
      )}

      <div style={{ marginTop: 30, marginBottom: 30, height: 1, width: 320, backgroundColor: '#0005' }} />
    </div>
  )
}

const headerStyle = { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }

const parseArray = value => {
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}
